import { render, staticRenderFns } from "./CostsTable.vue?vue&type=template&id=1baa1696&scoped=true&"
import script from "./CostsTable.vue?vue&type=script&lang=js&"
export * from "./CostsTable.vue?vue&type=script&lang=js&"
import style0 from "./CostsTable.vue?vue&type=style&index=0&id=1baa1696&lang=scss&scoped=true&"
import style1 from "./CostsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa1696",
  null
  
)

export default component.exports